import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = (acceptanceId) =>
  request.delete(
    'Acceptance/delete_acceptance',
    { acceptanceId },
    'Не удалось удалить приемки',
    'Error'
  );

export const useDeleteAcceptance = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
